import styles from "../component/PurchaseApprovalForm.module.css";

const MapStatusClass = (status) => {
  if (!status) return "";

  const statusMap = {
    pending: styles.pending,
    "pending approval": styles.pending_for_approval,
    approved: styles.approved,
    "approval reverted": styles.rejected,
    completed: styles.completed,
    cancelled: styles.cancelled,
  };

  return statusMap[status.toLowerCase()] || "";
};

export default MapStatusClass;
